import EventEmitter from "eventemitter3";

const eventsCenter = new EventEmitter();

export default eventsCenter;

export const WEBSOCKET = {
  CONNECTED: "CONNECTED",
};

export const EVENTCMD = {
  PlayGame: "PlayGame",
  AfterExitGame: "AfterExitGame",
  PlayerStatus: "PlayerStatus",
  Logout: "logout",
  CloseGameWindowIfNeeded: "CloseGameWindowIfNeeded",
  checkGameWidnowExist: "checkGameWidnowExist",
  echoGameWidnowExist: "echoGameWidnowExist",
  // 重置检测挂机
  ResetAwayFromKeyboard: "ResetAwayFromKeyboard",
  notifyWebrtcRendered: "notifyWebrtcRendered",
  StartCountDown: "StartCountDown", // 辅助启动进入游戏的倒计时读秒
  SetCurrentGameState: "SetCurrentGameState", // 同步两个tab页的游戏状态
};

export const CHANNELMSGTYPE = {
  Moniter: "Moniter",
  MouseShape: "MouseShape",
  MousePostion: "MousePostion",
};

export const WEBRTCMSGTYPE = {
  Message: "Message",
  Stream: "Stream",
  Error: "Error",
  Render: "render",
};

// 点击开启游戏
export const firePlayGameEvent = (item: any) => {
  eventsCenter.emit(EVENTCMD.PlayGame, {
    cmd: EVENTCMD.PlayGame,
    obj: item,
  });
};
